import { DropzoneArea } from "@skrice.studio/material-ui-dropzone-mui";
import { Button, Paper, Typography } from "@mui/material";
import Alert from "@mui/material/Alert";
import { withStyles } from "@mui/styles";
import axios from "axios";
import * as React from "react";

import { LoadingWrapper } from "../../components/LoadingWrapper";
import {Config} from "../../config/config";
import { Helpers } from "../../utils/helpers";
import { PopupMessage } from "../../utils/message";

interface FingerprintGeneratorState {
    files: any[];
    processing: boolean;
    error: string | null;
}

interface FingerprintGeneratorProps {
    activeUser: any;
    activeEnv: any;
    classes: any;
}

class UserImporterWrapped extends React.Component<FingerprintGeneratorProps, FingerprintGeneratorState> {

    constructor(props) {
        super(props);

        this.state = {
            files: [],
            processing: false,
            error: null,
        };

        document.title = Helpers.documentTitle("Import user");
    }

    importUser = () => {
        this.setState({ processing: true, error: null }, async () => {
            try {
                const formData = new FormData();
                formData.append("image", this.state.files[0]);

                await axios.post(`${Config.getInstance.apiUrl}/api/users/import`, formData, {
                    headers: {
                        "Authorization": Helpers.getSessionId(),
                        "Content-Type": "multipart/form-data",
                    },
                });

                PopupMessage.success("User imported!");

                this.setState({
                    processing: false,
                    files: [],
                });
            } catch (error) {
                this.setState({ processing: false, files: [] });

                PopupMessage.error("Error: " + error.response.data.error);
            }
        });
    }

    handleChange = (files) => this.setState({ files });

    render() {
        const { classes } = this.props;

        return (
            <div className="contentPadding">
                <Paper className="root" elevation={0}>
                    <div style={{ float: "left", padding: "15px 22px 15px 22px", width: "100%" }}>
                            <div className={classes.title}>
                                <Typography variant="h6" id="tableTitle">
                                    User importer
                                </Typography>
                            </div>
                        </div>

                        {this.state.error && <Alert severity="error">{this.state.error}</Alert>}

                        <div style={{ float: "left", width: "100%" }}>
                            <div style={{ padding: 20 }}>
                                <LoadingWrapper loading={this.state.processing}>
                                    <DropzoneArea
                                        onChange={this.handleChange}
                                        acceptedFiles={["application/zip", "application/octet-stream", "application/x-zip-compressed", "multipart/x-zip"]}
                                        showFileNamesInPreview={true}
                                        filesLimit={1}
                                        showFileNames={true}
                                    />

                                    {this.state.files.length > 0 && <div style={{ marginTop: 20 }}>
                                        <Button disableElevation variant="contained" onClick={this.importUser}>
                                            Import
                                        </Button>
                                    </div>}
                                </LoadingWrapper>
                            </div>
                        </div>
                </Paper>
            </div>
        );
    }
}

const styles: any = theme => ({
    actions: {
        color: theme.palette.text.secondary,
        float: "right",
    },
    button: {
        margin: 8,
    },
});

export const UserImporter = withStyles(styles)(UserImporterWrapped);
